<ion-header *ngIf="showHeader">

    <ion-toolbar>
        <ion-title>Technischen Alarm quittieren</ion-title>
    </ion-toolbar>

</ion-header>


<div class="main">
    <quit-technical></quit-technical>
</div>
